var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._v("加载中...")]):_c('div',{staticClass:"error"},[_c('div',[_vm._v("哎呀，系统出错了")]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.reLogin()}}},[_vm._v("重试")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }